export const SDK_VERSION = '7.39.0';
